jQuery(document).ready(function () {
    jQuery('.wm-logoCarousel .wp-block-gallery').slick({
        infinite: true,
        slidesToShow: 5,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
});
